import type { InteractionType } from '~/model/InteractionType';
import htmlReactParser from 'html-react-parser';
import { useLocale } from 'next-intl';
import { getLangAttributeValue } from '@/app/utils/entities/translation';
import { Author } from '~/components/commons/Author/Author';
import { retrieveTranslatedFieldsFromEntity } from '~/components/utils';
import { AcceptLanguage } from '~/const/locale';

export const AnnouncementPreview = ({
  interaction,
}: {
  interaction: InteractionType;
}) => {
  const locale = useLocale();
  const interactionData = retrieveTranslatedFieldsFromEntity({
    entityTranslated: false,
    entity: interaction,
    language: AcceptLanguage[locale],
  }) as InteractionType;

  const originalLocale = interaction?.original_locale;

  const interactionTitle = interactionData?.title;
  const interactionBody = interactionData?.body;

  const langValue = getLangAttributeValue(originalLocale, AcceptLanguage[locale]);

  return (
    <section className="announcement-card">
      <header className="announcement-card__header">
        <div
          lang={langValue}
          data-testid="announcement-preview"
          className="vp-title-l announcement-card__title"
        >
          {interactionTitle}
        </div>
        <div
          lang={langValue}
          className="vp-body-l announcement-card__description__preview"
        >
          {interactionBody && htmlReactParser(interactionBody)}
        </div>
        <Author
          user={interaction?.owner}
          beginDate={interaction?.start_at}
        />
      </header>
    </section>
  );
};
